<template>
    <div class="h-map" ref="container"></div>
</template>

<script>
import config from '@/config'
export default {
    name: 'h-map',
    props: {
        // 缩放大小
        zoom: {
            type: Number,
            default: 16
        },
        // 中心点
        center: {
            type: Object,
            default () {
                return {}
            }
        },
        // 标记
        // 轨迹
        // 范围
    },
    data () {
        return {
            BASE_URL: 'https://map.qq.com/api/js?v=2.exp',
            map: null,
            geoMarker: []
        }
    },
    methods: {
        /**
         * @description 初始化地图
         * @author yangyu
         */
        initMap () {
            let that = this
            this.map = new qq.maps.Map(this.$refs.container, {
                zoom: this.zoom
            })
            this.geocoder = new qq.maps.Geocoder({
                complete: result => {
                    this.map.setCenter(result.detail.location)
                    // 清空之前的标记
                    this.geoMarker.forEach(m => m.setMap(null))
                    this.geoMarker = []
                    let marker = new qq.maps.Marker({
                        map: this.map,
                        position: result.detail.location
                    })
                    this.geoMarker.push(marker)
                    this.$emit('get-location-success', result.detail.location)
                }
            })
            // 判断是否传入中心点，如果没有则使用ip地址定位中心点
            if (this.center && this.center.lat !== undefined && this.center.lng !== undefined) {
                this.map.setCenter(new qq.maps.LatLng(this.center.lat, this.center.lng))
                this.geoMarker.push(new qq.maps.Marker({
                    map: this.map,
                    position: new qq.maps.LatLng(this.center.lat, this.center.lng)
                }))
            } else {
                // 根据默认ip定位当前位置
                let citylocation = new qq.maps.CityService({
                    complete: result => {
                        this.map.setCenter(result.detail.latLng)
                    }
                })
                //调用searchLocalCity();方法    根据用户IP查询城市信息。
                citylocation.searchLocalCity()
            }
        },
        /**
         * @description
         */
        getLocationByAddress (address) {
            this.geocoder.getLocation(address)
        }
    },
    mounted () {
        // this.loadScript()
        this.$nextTick(() => {
            this.initMap()
        })
    }
}
</script>

<style lang="less">
.h-map {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue